// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","260":"ae51ba48","532":"styles"}[chunkId] + "-" + {"230":"c2160ac6923e3f616e26","256":"fbede486b8a653564f50","260":"5c8cf99503b8d83b46a1","532":"122b0869fe651dabc2a6"}[chunkId] + ".js";
};